import { BaseModel } from "model/BaseModel";
import ClasseAuditoria from "./ClasseAuditoria";
import RequisitoAuditoria from "../requisitoAuditoria/RequisitoAuditoria";
import ComentarioAuditoria from "./ComentarioAuditoria";
import AcaoAuditoria from "./AcaoAuditoria";
import { OpcaoRespostaRequisito } from "../requisitoAuditoria/OpcaoRespostaRequisito";
import OpcaoRespostaItemAuditoria from "./OpcaoRespostaItemAuditoria";

export default class ItemClasseAuditoria implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    descricao: string;
    resultado: string;
    status: string;
    resposta: string;
    requisitoAuditoria: RequisitoAuditoria;
    classeAuditoria: ClasseAuditoria;
    acoesAuditoria: AcaoAuditoria[];
    comentariosAuditoria: ComentarioAuditoria[];
    opcoesResposta: OpcaoRespostaItemAuditoria[];
    tipoResposta: string;
    ultimaExecucao: Date | null;
    respoastaEscolhida: string;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        descricao = '',
        resultado = '',
        status = '',
        resposta = '',
        requisitoAuditoria = new RequisitoAuditoria(),
        classeAuditoria = new ClasseAuditoria(),
        acoesAuditoria = [],
        comentariosAuditoria = [],
        opcoesResposta = [],
        tipoResposta = 'TEXTO',
        ultimaExecucao = null,
        respostaEscolhida = ""
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.descricao = descricao;
        this.resultado = resultado;
        this.status = status;
        this.resposta = resposta;
        this.requisitoAuditoria = requisitoAuditoria;
        this.classeAuditoria = classeAuditoria;
        this.acoesAuditoria = acoesAuditoria;
        this.comentariosAuditoria = comentariosAuditoria;
        this.opcoesResposta = opcoesResposta;
        this.tipoResposta = tipoResposta;
        this.ultimaExecucao = ultimaExecucao;
        this.respoastaEscolhida = respostaEscolhida;
    }
}